import { render, staticRenderFns } from "./DialogTenderImport.vue?vue&type=template&id=6602c46c"
import script from "./DialogTenderImport.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderImport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports